import $ from 'jquery';
import _ from 'lodash';

export const setAlignStyle = ($origin, $toAlign, $origin0, $toAlign0) => {
    const originList = $origin;
    const transList = $toAlign;
    let isSettedOffsetTop = false;
    if (!originList.length || !transList.length || originList.length !== transList.length) return;
    // 指定需要计算顶部偏移的元素
    if ($origin0 && $toAlign0) {
        const distance = $origin0.offset().top - $toAlign0.offset().top;
        (distance > 0 ? $toAlign0 : $origin0).css('margin-top', `${Math.abs(distance)}px`);
        isSettedOffsetTop = true;
    }
    _.forEach(originList, (item, index) => {
        if (!item || !transList[index]) return;
        const $origin = $(item);
        const $trans = $(transList[index]);
        const originHeight = $origin.height();
        const transHeight = $trans.height();
        if (!isSettedOffsetTop && index === 0) {
            const distance = $origin.offset().top - $trans.offset().top;
            (distance > 0 ? $trans : $origin).css('margin-top', `${Math.abs(distance)}px`);
        }
        if (originHeight === transHeight) {
            return;
        } else if (originHeight > transHeight) {
            $trans.css('height',`${originHeight}px`);
        } else {
            $origin.css('height',`${transHeight}px`);
        }
    });
};

export const removeAlignStyle = ($origin, $align, $origin0, $toAlign0) => {
    const originList = $origin;
    const transList = $align;
    _.forEach(originList, item => {
        if (!item) return;
        $(item).removeAttr('style');
    });
    _.forEach(transList, item => {
        if (!item) return;
        $(item).removeAttr('style');
    });
    if ($origin0) $origin0.removeAttr('style');
    if ($toAlign0) $toAlign0.removeAttr('style');
};
